import React from 'react';

import logoImage from '../../assets/siteicon.png';

import css from './FullScreenLogoLoader.module.css';

const FullScreenLogoLoader = () => {
  return (
    <div className={css.loadingOverlay} role="status" aria-live="polite" aria-label="Loading">
      <div className={css.loadingSpinner}>
        <img src={logoImage} alt="Loading" className={css.spinningLogo} />
      </div>
    </div>
  );
};

export default FullScreenLogoLoader;
